import { Container, Grid } from "@mui/material";
import SvgColor from '@src/components/svg-color';
import { AppWidgetSummary } from "@src/sections/@dashboard/app";
import palette from '@src/theme/palette';
import numeral from "numeral";
import { useSummaryService } from "./hooks";
import { usePurchasesContext } from "../provider";
import moment from "moment";

const Header = () => {
	const { state } = usePurchasesContext();
	const { totalPurchase } = useSummaryService();

	return (
		<Container>
			<Grid container 
				spacing={{
					xl: 3,
					lg: 3,
					md: 3,
					sm: 1.5,
					xs: 1.5
				}}>
				<Grid item xs={12} sm={6} md={6} >
					<AppWidgetSummary
						disabled
						title={`Total Points ${state.fromdate && state.todate ? 
							`(${moment(state.fromdate).format("DD MMM YYYY")} - ${moment(state.todate).format("DD MMM YYYY")})` 
							: `(${moment().format("MMMM")})`}`}
						value={numeral(totalPurchase?.totalAmount).format("0,000.00")}
						color={palette.orangeYellow.main}
						icon={<SvgColor src={`/assets/icons/ic_palm_tree.svg`} sx={{ width: 24, height: 24 }} />}
					/>
				</Grid>
			</Grid>
		</Container>
	)
}

export default Header